export const TABLE_COLUMNS = [
  {
    Header: 'Date',
    accessor: 'localDate',
  },
  {
    Header: 'Date Type',
    accessor: 'dateType.label',
  },
  {
    Header: 'Carrier',
    accessor: 'carrier.label',
  },
  {
    Header: 'Postal Operator',
    accessor: 'postalOperator.label',
  },
  {
    Header: 'Origin',
    accessor: 'origin',
  },
  {
    Header: 'Dest',
    accessor: 'destination',
  },
  {
    Header: 'Mail Class',
    accessor: 'mailClass.label',
  },
  {
    Header: 'Receptacle ID',
    accessor: 'receptacleId',
  },
  {
    Header: 'Approval Status',
    accessor: 'approvalStatus',
  },
  {
    Header: 'Comments',
    accessor: 'comments',
  },
];
